import {useCallback, useState} from "react";
import {HttpMethod, initFetch} from "../utils/fetcher";

/**
 * Hook pour recherche les lots de différentes facon.
 * @returns {{data: *[], loading: boolean, error: unknown, success: boolean, createDocket: *, fromBuilding: (function(*): Promise<void>)|*}}
 */
const useProducts = () => {

	const [data, setData] = useState([]);

	const [loading,setLoading] = useState(false);
	const [error, setError] = useState(null);
	//const [success, setSuccess] = useState(false);

	// Liste les lots selon l'immeuble
	const fromBuilding = useCallback(async (building_id) => {

		setData([]);
		setLoading(true);
		setError(null);

		try {
			const {url, params} = initFetch(`products-building/${building_id}`, HttpMethod.GET);
			const response = await fetch(url, params);

			if (!response.ok) {
				throw new Error(`Erreur HTTP returned ${response.status}`);
			}

			const result = await response.json();

			if (!result.status) {
				throw new Error(`Erreur returned ${response.message}`);
			}

			setData({products: result.products, buildings: result.buildings});


		} catch (e) {
			setError(e.message);
		} finally {
			setLoading(false);
		}
	},[]);


	return {
		// Données
		data,

		// États
		loading,
		error,
		//success,

		// Actions
		fromBuilding
	};
}

export default useProducts;